import React, { ReactElement } from "react";
import { WidgetProps } from "@rjsf/utils";
import Input, {
  InputProps
} from "@amzn/awsui-components-react-v3/polaris/input";
import { placeholder } from "../utils";

type Props = WidgetProps & {
  type?: InputProps.Type; // Trust that RJSF passes the HTML type value, which Polaris also uses
};
export default function BaseInputTemplate(props: Props): ReactElement {
  return (
    <Input
      data-id={props.id}
      type={props.type}
      value={props.value}
      placeholder={placeholder(props)}
      onBlur={() => props.onBlur(props.id, null)}
      onChange={e => props.onChange(e.detail.value)}
      onFocus={() => props.onFocus(props.id, null)}
      disabled={props.disabled}
      readOnly={props.readonly}
      ariaRequired={props.required}
    />
  );
}
